import { combineReducers } from 'redux';
import Auth from './AuthReducer'
import Common from './CommonReducer'
import Tour from './TourReducer'
import DayTourList from './DayTourListReducer'
import RoundTourList from './RoundTourListReducer'
import MaldiveTourList from './MaldiveTourListReducer'
import ThingsToDoList from './ThingsToDoListReducer'
import HelpReducer from './HelpReducer'
import TourDetailsReducer from './TourDetailsReducer'
import CheckoutReducer from './CheckoutReducer'

export default combineReducers({    
    Auth,
    Common,
    Tour,
    DayTourList,
    RoundTourList,
    MaldiveTourList,
    ThingsToDoList,
    HelpReducer,
    TourDetailsReducer,
    CheckoutReducer
})